'use strict';

// show advice when click on criterium
$(document).on('click', '.criterium', function (event) {
  var $this = $(this);

  if (!($(event.target).closest('a, .no-advice-target').length > 0)) {
    event.preventDefault();
    $this.toggleClass('open-crit').find('.criterium-advice').slideToggle(100);
  }
});
